import { ReactNode } from 'react';

interface CrmDetailLayoutProps {
	left: ReactNode;
	center: ReactNode;
	right: ReactNode;
	topBar?: ReactNode;
}

/**
 * 3-column detail layout used by Contact / Company / Deal detail pages.
 * - left: identity header, quick actions, about card
 * - center: tabs, AI summary, data highlights, activity timeline
 * - right: associations (deals, companies, contacts, attachments, ...)
 *
 * Below `lg` breakpoint the columns stack: left → right (drawer-style) → center.
 * Above `lg`, the center is the widest column (similar to HubSpot's record view).
 */
export function CrmDetailLayout({ left, center, right, topBar }: CrmDetailLayoutProps) {
	return (
		<div className="min-h-[calc(100vh-4rem)] bg-muted/30">
			{topBar && (
				<div className="border-b bg-background px-4 md:px-6 py-2">{topBar}</div>
			)}
			<div className="grid gap-4 p-4 md:p-6 lg:grid-cols-[300px_minmax(0,1fr)_320px] xl:grid-cols-[320px_minmax(0,1fr)_360px]">
				<aside className="space-y-4 lg:sticky lg:top-4 lg:h-[calc(100vh-2rem)] lg:overflow-y-auto lg:pr-1 -lg:order-1">
					{left}
				</aside>
				<main className="space-y-4 min-w-0">{center}</main>
				<aside className="space-y-4 lg:sticky lg:top-4 lg:h-[calc(100vh-2rem)] lg:overflow-y-auto lg:pr-1">
					{right}
				</aside>
			</div>
		</div>
	);
}
